module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      F. Paul Wilson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("F. Paul Wilson is the author of more than fifty books spanning various genres, including science fiction, horror, thriller, and more. Four of his novels have been "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestsellers, and his work has earned him four Prometheus Awards, the prestigious Inkpot Award from the San Diego Comic-Con, and the Pioneer Award from the RT Booklovers Convention.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bIAC8K/tc-custom/9781250177322.jpg?1737774790968",
      "alt": "This image is the cover for the book The Void Protocol, The ICE Sequence"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Void Protocol, The ICE Sequence\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author concludes his supernatural thriller trilogy as powerful cosmic entities reveal their terrifying agenda.")]), _c('br'), _c('br'), _vm._v("Something sits in a bunker lab buried fifty feet below the grounds of Lake Hurst Naval Air Station. The product of experimental technology confiscated from the Germans after World War II, it occupies a chamber of steel-reinforced ballistic glass. Despite intensive study for nearly three-quarters of a century, no one knows what it is. But illegal human research reveals what it can do."), _c('br'), _c('br'), _vm._v("Humans with special abilities have been secretly collected—abilities that can only have come from whatever occupies the underground bunker in Lakehurst. And so it sits, sequestered on the edge of the New Jersey Pine Barrens, slowly changing the world.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0